const ASSETS = window.THEME_ASSETS || 'assets/';
const $ = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];

const PRICE = 35, BUNDLE_PRICE = 94.5, VARIANT = '45982469652659', BUNDLE_VARIANT = '46310718898355', DISCOUNT_CODE = '';
const fmt = n => '$' + n.toFixed(2);
let packMode = '1';
const total = n => fmt(packMode === '3' ? BUNDLE_PRICE * n : PRICE * n);
const motion = matchMedia('(prefers-reduced-motion: reduce)');
const lowData = !!navigator.connection?.saveData;

let qty = 1;
function checkoutUrl(n) {
  const v = packMode === '3' ? BUNDLE_VARIANT : VARIANT;
  const code = DISCOUNT_CODE && packMode === '3' ? '?discount=' + encodeURIComponent(DISCOUNT_CODE) : '';
  return `https://22boost.com/cart/${v}:${n}${code}`;
}
function syncCheckout() {
  $$('[data-direct-checkout]').forEach(a => a.href = checkoutUrl(qty));
}

function setQty(n) {
  qty = Math.max(1, Math.min(99, n));
  $('#quantity').textContent = qty;
  syncCheckout();
  $('#add-price').textContent = total(qty);
  $('#qty-minus').disabled = qty === 1;
  $('#qty-plus').disabled = qty === 99;
}

const open = id => $('#' + id).showModal();
$$('[data-close]').forEach(b => b.addEventListener('click', () => $('#' + b.dataset.close).close()));
$$('dialog').forEach(d => {
  let downOnBackdrop = false;
  d.addEventListener('pointerdown', e => { downOnBackdrop = e.target === d; });
  d.addEventListener('click', e => {
    if (e.target !== d || !downOnBackdrop) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  });
});

$('#qty-minus').onclick = () => setQty(qty - 1);
$('#qty-plus').onclick = () => setQty(qty + 1);
$('#facts-open').onclick = () => open('facts');

$$('[name="pack"]').forEach(r => r.addEventListener('change', () => {
  packMode = r.value;
  $('#bundle-note').hidden = r.value !== '3';
  setQty(1);
}));
$$('[data-pick-bundle]').forEach(a => a.addEventListener('click', () => {
  const r = $('[name="pack"][value="3"]');
  r.checked = true;
  r.dispatchEvent(new Event('change'));
}));

const menu = $('.menu'), nav = $('#nav');
menu.onclick = () => {
  const isOpen = nav.classList.toggle('open');
  menu.setAttribute('aria-expanded', isOpen);
  menu.textContent = isOpen ? 'Close' : 'Menu';
};
$$('#nav a').forEach(a => a.addEventListener('click', () => {
  nav.classList.remove('open');
  menu.setAttribute('aria-expanded', 'false');
  menu.textContent = 'Menu';
}));

const hero = $('#hero-video'), toggle = $('#video-toggle');
const syncToggle = () => {
  toggle.textContent = hero.paused ? 'Play' : 'Pause';
  toggle.setAttribute('aria-label', hero.paused ? 'Play video' : 'Pause video');
};
let userPaused = false;
hero.addEventListener('play', syncToggle);
hero.addEventListener('pause', syncToggle);
toggle.onclick = () => { userPaused = !hero.paused; hero.paused ? hero.play().catch(syncToggle) : hero.pause(); };
syncToggle();
const autoplay = !motion.matches && !lowData && 'IntersectionObserver' in window;
if (autoplay) new IntersectionObserver(([e]) => { if (e.isIntersecting && !userPaused) hero.play().catch(syncToggle); else if (!e.isIntersecting) hero.pause(); }, { threshold: .25 }).observe(hero);
motion.addEventListener?.('change', e => { if (e.matches) hero.pause(); });

const gImg = $('#g-img'), thumbs = $$('.thumb');
let swapId = 0;
thumbs.forEach(t => t.onclick = () => {
  thumbs.forEach(x => { x.classList.toggle('on', x === t); x.setAttribute('aria-pressed', x === t); });
  // decode the next photo before swapping so it fades instead of flashing
  const id = ++swapId, next = new Image();
  next.sizes = gImg.sizes;
  next.srcset = t.dataset.srcset || '';
  next.src = t.dataset.src;
  gImg.classList.add('swap');
  const show = () => {
    if (id !== swapId) return;
    gImg.srcset = next.srcset;
    gImg.src = t.dataset.src;
    gImg.alt = t.dataset.alt;
    gImg.classList.remove('swap');
  };
  (next.decode ? next.decode() : Promise.resolve()).then(show, show);
});
// swipe between photos on touch screens
let touchX = 0, touchY = 0;
const galleryMain = $('.gallery-main');
galleryMain.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; }, { passive: true });
galleryMain.addEventListener('touchend', e => {
  const dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY;
  if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
  const i = thumbs.findIndex(t => t.classList.contains('on'));
  thumbs[(i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
}, { passive: true });

const film = $('#story-film video');
$$('[data-watch-story]').forEach(b => b.onclick = () => { open('story-film'); hero.pause(); film.play().catch(() => {}); });
$('#story-film').addEventListener('close', () => film.pause());

$$('[data-shopify-form]').forEach(f => f.addEventListener('submit', () => {
  setTimeout(() => { f.reset(); const d = f.querySelector('.form-done'); if (d) d.hidden = false; }, 50);
}));

const PACK_NAMES = { 1: 'One pouch', 3: 'Three-pack' };
const syncBar = () => {
  const pack = $('[name="pack"]:checked').value;
  $('#bar-name').textContent = pack === '3' ? (qty > 1 ? `${qty} three-packs` : PACK_NAMES[3]) : (qty > 1 ? `${qty} pouches` : PACK_NAMES[1]);
  $('#bar-price').textContent = total(qty);
};
['#qty-minus', '#qty-plus'].forEach(s => $(s).addEventListener('click', syncBar));
$$('[name="pack"]').forEach(r => r.addEventListener('change', syncBar));
const bar = $('#buybar');
bar.hidden = false;
if ('IntersectionObserver' in window) {
  new IntersectionObserver(([e]) => bar.classList.toggle('show', !e.isIntersecting), { rootMargin: '0px 0px -40px 0px' }).observe($('.hero-buy .buy'));
}

const viral = $('#build');
const beats = $$('.beat'), media = $$('.cm'), chapters = $$('.chapters li');
const counters = $$('[data-count-to]');
const show = (el, v) => el.textContent = (el.dataset.prefix || '') + Math.round(v).toLocaleString('en-US') + (el.dataset.suffix || '');

if (viral && (motion.matches || !('IntersectionObserver' in window))) {
  viral.classList.add('static');
} else if (viral) {
  const wall = $('.viral-wall');
  const clips = ['ch-gap', 'ch-making', 'drop-loop', 'ch-ski', 'hero-jump'];
  const stills = ['social-0', 'social-2', 'social-8', 'social-1', 'social-3', 'social-11', 'social-5', 'social-7', 'social-4', 'social-6', 'social-9', 'social-10', 'founder-toss', 'founder-floor', 'founder-making'];
  const cells = innerWidth <= 760 ? 18 : 24;
  const nClips = innerWidth <= 760 ? 3 : 5;
  const clipAt = new Set(clips.slice(0, nClips).map((_, k) => Math.floor((k + .5) * cells / nClips)));
  const queue = [...stills];
  const tiles = [];
  for (let i = 0, c = 0; i < cells; i++) {
    let el;
    if (clipAt.has(i)) {
      el = document.createElement('video');
      Object.assign(el, { muted: true, loop: true, playsInline: true, preload: 'none' });
      el.dataset.src = `${ASSETS}${clips[c++]}.mp4`;
    } else {
      el = new Image();
      el.alt = '';
      el.decoding = 'async';
      el.dataset.src = `${ASSETS}${queue.shift() || stills[i % stills.length]}.webp`;
    }
    wall.append(el);
    tiles.push(el);
  }
  const order = tiles.map((t, i) => [Math.abs(Math.sin(i * 12.9898) * 43758.5453) % 1, t]).sort((a, b) => a[0] - b[0]).map(x => x[1]);

  const canvas = $('.viral-burst'), ctx = canvas.getContext('2d');
  let parts = [], dpr = 1;
  const resize = () => {
    dpr = Math.min(2, devicePixelRatio || 1);
    canvas.width = canvas.clientWidth * dpr;
    canvas.height = canvas.clientHeight * dpr;
  };
  resize();
  addEventListener('resize', resize);
  const glyphs = ['▶', '♥', '+1', '▶', '♥', '+1', '▶'];
  function burst(n, el) {
    const r = el.getBoundingClientRect(), c = canvas.getBoundingClientRect();
    for (let i = 0; i < n && parts.length < 420; i++) {
      const a = -Math.PI / 2 + (Math.random() - .5) * Math.PI * 1.5;
      const v = 3 + Math.random() * 9;
      parts.push({ x: r.left - c.left + Math.random() * r.width, y: r.top - c.top + r.height * (.2 + Math.random() * .6), vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1, g: glyphs[Math.random() * glyphs.length | 0], s: 14 + Math.random() * 22, spin: (Math.random() - .5) * .2, rot: 0 });
    }
  }
  let drawing = false;
  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    parts = parts.filter(p => p.life > 0);
    for (const p of parts) {
      p.x += p.vx; p.y += p.vy; p.vy += .12; p.vx *= .985; p.life -= .012; p.rot += p.spin;
      ctx.save();
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.translate(p.x * dpr, p.y * dpr);
      ctx.rotate(p.rot);
      ctx.fillStyle = '#fff';
      ctx.font = `800 ${p.s * dpr}px Archivo, system-ui, sans-serif`;
      ctx.textAlign = 'center';
      ctx.fillText(p.g, 0, 0);
      ctx.restore();
    }
    if (parts.length) requestAnimationFrame(draw); else drawing = false;
  }
  const kick = () => { if (!drawing) { drawing = true; requestAnimationFrame(draw); } };

  const N = beats.length, LOUD = 5;
  const range = i => [i / N, (i + 1) / N];
  const last = counters.map(() => 0), done = counters.map(() => false);
  let active = -1, ticking = false, visible = false;
  const playOnly = list => list.forEach(([v, on]) => { if (on) { if (!v.src && v.dataset.src) { v.src = v.dataset.src; } v.play().catch(() => {}); } else if (!v.paused) v.pause(); });
  function frame() {
    ticking = false;
    const r = viral.getBoundingClientRect();
    const p = Math.min(.9999, Math.max(0, -r.top / (r.height - innerHeight)));
    bar.classList.toggle('away', r.top <= 1 && r.bottom >= innerHeight - 1);
    const n = Math.floor(p * N);
    if (n !== active) {
      beats.forEach((b, i) => b.classList.toggle('on', i === n));
      chapters.forEach((c, i) => { c.classList.toggle('on', i === n); c.classList.toggle('done', i < n); });
      media.forEach((m, i) => m.classList.toggle('on', i === n));
      viral.classList.toggle('loud', n >= LOUD);
      active = n;
    }
    playOnly(media.filter(m => m.tagName === 'VIDEO').map(v => [v, visible && v.classList.contains('on') && n < LOUD]));
    const [ls] = range(LOUD);
    const lit = Math.round(cells * Math.min(1, Math.max(0, (p - ls + .04) / (1 / N * .8))));
    order.forEach((t, i) => {
      const on = i < lit;
      if (on && !t.src) t.src = t.dataset.src;
      t.classList.toggle('on', on);
    });
    playOnly(tiles.filter(t => t.tagName === 'VIDEO').map(v => [v, visible && v.classList.contains('on')]));
    counters.forEach((el, i) => {
      const [a, b] = range(LOUD + i);
      const t = Math.min(1, Math.max(0, (p - a) / ((b - a) * .7)));
      const end = +el.dataset.countTo, v = end * (1 - Math.pow(1 - t, 3));
      show(el, v);
      const d = Math.max(0, v - last[i]) / end;
      if (d > 0) { burst(Math.min(60, Math.ceil(d * 260)), el); kick(); }
      if (t >= 1 && !done[i]) { done[i] = true; burst(140, el); kick(); }
      if (t < 1) done[i] = false;
      last[i] = v;
    });
  }
  const onScroll = () => { if (visible && !ticking) { ticking = true; requestAnimationFrame(frame); } };
  addEventListener('scroll', onScroll, { passive: true });
  new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    if (!visible) bar.classList.remove('away');
    frame();
  }).observe(viral);
  counters.forEach(el => show(el, 0));
  frame();
}

setQty(1);

syncBar();

// Express wallets: swap the dynamic checkout form to match the selected pack.
$$('[name="pack"]').forEach(r => r.addEventListener('change', () => {
  const es = $('#express-single'), eb = $('#express-bundle');
  if (es) es.hidden = r.value === '3';
  if (eb) eb.hidden = r.value !== '3';
}));

// Email signup popup
const signup = $('#signup');
const SIGNUP_POPUP_ENABLED = false; // approved black design; shows after 4s of scrolling (Oct 27)
if (SIGNUP_POPUP_ENABLED && signup) {
  const KEY = 'bb-signup-v2';
  let seen = null;
  try { seen = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  const posted = new URLSearchParams(location.search).get('customer_posted');
  if (posted === 'true') {
    $('#signup-join').hidden = true;
    $('#signup-done').hidden = false;
    signup.showModal();
    try { localStorage.setItem(KEY, JSON.stringify({ done: 1 })); } catch (e) {}
    history.replaceState(null, '', location.pathname);
  } else if (!seen || (!seen.done && Date.now() - (seen.t || 0) > 7 * 864e5)) {
    let start = 0, shown = false;
    addEventListener('scroll', () => {
      if (shown || signup.open || document.querySelector('dialog[open]')) return;
      const now = Date.now();
      if (!start) { start = now; return; }
      if (now - start >= 4000) { shown = true; signup.showModal(); }
    }, { passive: true });
  }
  // Only the explicit close button counts as a dismissal (7 days). Accidental or
  // programmatic closes (backdrop, captcha handoff) must not hide the popup for a week.
  signup.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => {
    if (posted !== 'true') try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now() })); } catch (e) {}
  }));
  // Shopify's hcaptcha challenge renders below the modal dialog's top layer.
  // When a visible challenge appears, close the dialog so the visitor can reach it;
  // the verified submission returns to ?customer_posted=true and reopens the success state.
  setInterval(() => {
    if (!signup.open) return;
    const challenge = [...document.querySelectorAll('iframe[src*="hcaptcha"]')]
      .find(f => !f.closest('#signup') && f.offsetWidth > 200 && f.offsetHeight > 150);
    if (challenge) signup.close();
  }, 500);
}
